// schema/nodes/hard-break.ts
var HARD_BREAK_SCHEMA = () => ({
  inline: true,
  group: "inline",
  selectable: false,
  attrs: {
    class: {
      default: null
    }
  },
  parseDOM: [
    {
      tag: "br",
      getAttrs(node) {
        return {
          class: node.getAttribute("class")
        };
      }
    }
  ],
  toDOM(node) {
    return ["br", { class: node.attrs.class }];
  }
});
var HARD_BREAK_KEY = "hard-break";
var HARD_BREAK = {
  [HARD_BREAK_KEY]: HARD_BREAK_SCHEMA
};
export {
  HARD_BREAK,
  HARD_BREAK_KEY,
  HARD_BREAK_SCHEMA
};
